<app-queue
  *ngIf="(queue$ | async).length"
  #queueComponent
  [queue]="queue$ | async"
  (updateQueue)='handleUpdateQueue($event)'
  (removeBorrower)='handleDeleteBorrowerFromUserQueue($event)'
  (clearQueue)='handleClearUserQueue()'
></app-queue>
